var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45mm",
    height: "45mm",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#71717a",
    fillOpacity: 0.25,
    fillRule: "evenodd",
    stroke: "#000",
    strokeOpacity: 0.4,
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    x: 1.1322925,
    y: 1.1322916,
    width: 10,
    height: 10,
    d: "m3.7781 1.1323h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 12.132293,
    y: 1.1322916,
    width: 10,
    height: 10,
    d: "m14.778 1.1323h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 1.1322925,
    y: 12.132292,
    width: 10,
    height: 10,
    d: "m3.7781 12.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 12.132293,
    y: 12.132292,
    width: 10,
    height: 10,
    d: "m14.778 12.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 23.132292,
    y: 12.132292,
    width: 10,
    height: 10,
    d: "m25.778 12.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 12.132293,
    y: 23.132292,
    width: 10,
    height: 10,
    d: "m14.778 23.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 23.132292,
    y: 23.132292,
    width: 10,
    height: 10,
    d: "m25.778 23.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 34.132294,
    y: 23.132292,
    width: 10,
    height: 10,
    d: "m36.778 23.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 1.1322916,
    y: 34.13229,
    width: 10,
    height: 10,
    d: "m3.7781 34.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 12.132293,
    y: 34.13229,
    width: 10,
    height: 10,
    d: "m14.778 34.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 23.132292,
    y: 34.13229,
    width: 10,
    height: 10,
    d: "m25.778 34.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    x: 34.132294,
    y: 34.13229,
    width: 10,
    height: 10,
    d: "m36.778 34.132h4.7083a2.6458 2.6458 45 0 1 2.6458 2.6458v4.7083a2.6458 2.6458 135 0 1-2.6458 2.6458h-4.7083a2.6458 2.6458 45 0 1-2.6458-2.6458v-4.7083a2.6458 2.6458 135 0 1 2.6458-2.6458z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2c5bd32074382c7ca63ff6c395b9cc1.svg";
export { ForwardRef as ReactComponent };